'use strict'

import Vue from 'vue'
import Router from 'vue-router'
import {routers} from './router'
import utils from "@/utils"



// 路由配置
const RouterConfig = {
  routes: routers,
  mode:'history'
};

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err =>err)
}

Vue.use(Router)

const router = new Router(RouterConfig);


router.beforeEach((to, from, next) => {
    
    if (!utils.checkLogin()) {   //没有token
        if (to.name === 'app-login') {
			next();
		} else {
			next({name: 'app-login'});
		}
	} else {    
		//有token
		if (to.name === 'app-login') {
			next({
			  name: 'home'
			});
		}else{
            next();
		}
    }
});

export default router
